module.exports = __webpack_public_path__ + "static/media/mc_web_timeline_50_s.7fb72964.png";